module.exports = __webpack_public_path__ + "img/ring_g_l_0_null.74acde7b.png";